import ArrowIcon from '@assets/icons/arrow-right.svg?react'
import LetterIcon from '@assets/icons/email.svg?react'
import LockIcon from '@assets/icons/lock.svg?react'
import { CoreInput, MMButton } from '@components'
import ForgottenPasswordModal from '@components/ForgottenPasswordModal'
import cn from 'classnames'
import { paths, useLoginQry } from 'mmfintech-backend-api'
import type { LoginIntent } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { type BaseSyntheticEvent, useContext, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import styles from './LoginForm.module.scss'

const LoginForm = () => {
  const { modalShow } = useContext(GlobalContext)

  const location = useLocation()

  const { formValues, login, loginError, resetLogin } = useLoginQry((response: LoginIntent) => {
    if (window && response?.userId) {
      localStorage.setItem('cookieTimestamp', response.userId.toString())
    }
  })

  const handleForgotPassword = () => {
    modalShow({
      header: tr('PORTAL.FORGOT_PASSWORD.TITLE', 'Forgot password'),
      content: <ForgottenPasswordModal />
    })
  }

  useEffect(() => {
    if (location?.state?.from?.search === '?forgotPassword') {
      modalShow({
        header: tr('PORTAL.FORGOT_PASSWORD.TITLE', 'Forgot password'),
        content: <ForgottenPasswordModal />
      })
    }
  }, [location.state?.from?.search])

  const handleSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    login()
  }

  return (
    <div className={styles['login-form']}>
      <h2>{tr('FRONTEND.LOGIN.SIGNIN_BUTTON', 'Sign in')}</h2>

      <form onSubmit={handleSubmit}>
        <div className='form-inputs'>
          <CoreInput
            data-test='email'
            label={tr('FRONTEND.LOGIN.EMAIL', 'Email')}
            type='text'
            LeftIcon={<LetterIcon />}
            autoComplete='on'
            size='large'
            maxLength={320}
            {...formValues.registerInput('email', resetLogin)}
          />

          <CoreInput
            data-test='password'
            label={tr('FRONTEND.LOGIN.PASSWORD', 'Password')}
            type='password'
            LeftIcon={<LockIcon />}
            size='large'
            maxLength={30}
            {...formValues.registerInput('password', resetLogin)}
          />

          <div className={styles['forgot-password-link']} data-test='forgot-password'>
            <span className={cn(styles['forgot-password-trigger'], 'forgot-password-trigger')} onClick={handleForgotPassword}>{tr('FRONTEND.LOGIN.FORGOT_PASSWORD', 'Forgot password?')}</span>
          </div>
        </div>

        <div className='form-actions'>
          <ErrorDisplay error={loginError} />

          <MMButton
            type='submit'
            size='large'
            caption={tr('FRONTEND.LOGIN.BUTTON_LOGIN', 'Sign in')}
            // loading={loginFetching}
            disabled={!formValues.getValue('email') || !formValues.getValue('password')}
            fullWidth
          />

          <div className={styles['auth-signup-link']} data-test='dont-have-account-test'>
            {tr('FRONTEND.LOGIN.NO_ACCOUNT', "Don't have an account?")}

            <Link to={paths.signUp()} data-test='sign-up'>
              <span>{tr('FRONTEND.SIGNUP.NEW_TITLE', 'Sign up')}</span> <ArrowIcon />
            </Link>
          </div>
        </div>
      </form>
    </div>
  )
}

export default LoginForm
